import React, { Component } from 'react';
import { getAddressChangeStatus } from '../../address/actions/addressActions'; 

class AddressUpdateConfirmation extends Component {
    render() {
        const { actions: { goToUpdateContacts, goToUpdateAddress, goToAddAddress, goBackToSavedRoute }, booking } = this.props;
        const { jobId } = this.props.routeParams;
        
        const { hasPendingPrimaryAddress, hasPendingDeliveryAddress } = getAddressChangeStatus(booking); 
        const details = booking.details;

        return (
            <div>
                <h2 className="client-text">What would you like to do?</h2>
                <div className="row">
                    <div className="col-md-12 m-b-10">
                        <button type="button" className="btn btn-client btn-lg btn-block m-t-10" onClick={goToUpdateContacts.bind(this, jobId)}>Update Primary Contact</button>
                    </div>
                    <div className="col-md-12 m-b-30">
                        { hasPendingPrimaryAddress ? (
                            <div className="alert alert-warning text-center m-t-10 m-b-5 clearfix" role="alert">
                                A Business Address change is pending approval and cannot be updated.
                            </div>
                        ) : null}
                        <button type="button" className="btn btn-client btn-lg btn-block" disabled={hasPendingPrimaryAddress} onClick={goToUpdateAddress.bind(this, jobId)}>Update Business Address</button>
                    </div>
                    <div className="col-md-12 m-b-20">
                        <h3>Deliver my terminal to an alternative address:</h3>
                        <div className="alert alert-warning text-center m-b-5 clearfix" role="alert">
                            { hasPendingDeliveryAddress ? (
                                <span>A Delivery Address change is pending approval and cannot be updated.</span>
                            ) : (
                                <b>Please only specify if different to the business address.</b>
                            )}
                        </div>
                        <button type="button" className="btn btn-client btn-lg btn-block" disabled={hasPendingDeliveryAddress} onClick={goToAddAddress.bind(this, jobId)}>Specify Delivery Address</button>
                    </div>
                     <div className="col-md-12 m-t-20 m-b-5">
                        {hasPendingPrimaryAddress || hasPendingDeliveryAddress ? (
                            <div className="alert alert-info text-center" role="alert">
                                <p><b>We will let you know once your changes have been approved.</b></p>
                            </div>
                        ) : null}
                        <button type="button" className="btn btn-client-alt btn-lg btn-block" onClick={goBackToSavedRoute}>Continue Booking</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddressUpdateConfirmation;


// WEBPACK FOOTER //
// ./app/booking/components/addressUpdateConfirmation.js